import { useEffect, useState } from "react";
import { NavLink, Navigate, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutList, FolderTree, Menu as MenuIcon, FileEdit, Images, LogOut, ExternalLink } from "lucide-react";
import { adminApi, getToken, setToken, assetUrl } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { cn } from "@/lib/utils";

const LINKS = [
  { to: "/admin", label: "Listings", icon: LayoutList, end: true, id: "listings" },
  { to: "/admin/groups", label: "Groups", icon: FolderTree, id: "groups" },
  { to: "/admin/menu", label: "Menu Manager", icon: MenuIcon, id: "menu" },
  { to: "/admin/content", label: "Website Content", icon: FileEdit, id: "content" },
  { to: "/admin/media", label: "Media Library", icon: Images, id: "media" },
];

export default function AdminLayout() {
  const { content } = useSite();
  const nav = useNavigate();
  const [me, setMe] = useState(null);
  const token = getToken();

  useEffect(() => {
    if (token) adminApi.get("/auth/me").then((r) => setMe(r.data)).catch(() => {});
  }, [token]);

  if (!token) return <Navigate to="/admin/login" replace />;
  const logout = () => { setToken(null); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-[#F6F4F0] font-arial-all md:flex" data-testid="admin-layout">
      <aside className="md:w-60 md:min-h-screen bg-charcoal text-white md:sticky md:top-0 md:h-screen flex md:flex-col">
        <Link to="/" className="hidden md:block p-5 border-b border-white/10"><img src={assetUrl(content.general.logo)} alt="ISD" className="h-8 w-auto" /></Link>
        <nav className="flex md:flex-col overflow-x-auto md:overflow-visible flex-1 p-2 md:p-3 gap-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => cn("flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm whitespace-nowrap transition-colors", isActive ? "bg-brand text-white" : "text-white/70 hover:bg-white/10 hover:text-white")} data-testid={`admin-nav-${l.id}`}>
              <l.icon className="h-4 w-4" />{l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-2 md:p-3 md:border-t border-white/10 flex md:flex-col gap-1">
          {me && <p className="hidden md:block px-3 pb-2 text-xs text-white/50 truncate" data-testid="admin-user-email">{me.email}</p>}
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm text-white/70 hover:bg-white/10" data-testid="admin-view-site"><ExternalLink className="h-4 w-4" /><span className="hidden md:inline">View site</span></a>
          <button type="button" onClick={logout} className="flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm text-white/70 hover:bg-white/10" data-testid="admin-logout"><LogOut className="h-4 w-4" /><span className="hidden md:inline">Log out</span></button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-4 sm:p-8">
        <Outlet />
      </main>
    </div>
  );
}
